import { createContext } from 'react';
import {ID, Response} from '../../../../../_dashboard/helpers'
import { string } from 'yup';

export type Role = {
  name: string,
  _id?: string,
  id?: string
}

export interface Category {
  Title:string,
  Star: number,
}

export interface City {
  id?: number;
  name: string;
  country: string;
}
export interface Facility {
  _id?: string;
  title: string;
  category: string;
  translations: Array<{ title: string }>;
}
export interface Option {
  title: string;
}
export interface Hotel {
  _id?: ID;
  name: string;
  Category: Category;
  City: City;
  address: string;
  image: string;
  Facilities: Facility[];
  options:Option[];
  themes: string[];
  description?:string;
  seoDescription?:string
  seoSlug?:string
  seoImage?:string;
  seoTitle?:string;
  seoKeywords?:string[];
  isActive?: boolean;
  page?:number

}



export const initialHotel: Hotel = {

 
  name: '',
  Category: {
  
    Title: '',
    Star: 0,
  },
  City: {

    name: '',
    country:""
  },
  address: '',
 
  image: '',
  Facilities: [],
  options: [],
  themes: [],
  seoDescription:'',
  description:'',
  seoImage:'',
  seoTitle:'',
  seoSlug:'',
  seoKeywords: [],
};
export type HotelsQueryResponse = Response<Array<Hotel>>;
export type QueryResponseHotelContextProps<T> = {
  dataResponse?: Response<Array<T>> | undefined
  refetchData: () => void
  isLoading: boolean
  query: any
}
export function createHotelResponseContext<T>(initialState: QueryResponseHotelContextProps<T>) {
  return createContext(initialState)
}
export const initialHotelQueryResponse = { refetchData: () => { }, isLoading: false, query: '' }